import * as React from "react";
import { memo } from "react";
const SvgOwnedItems = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.05 18.0001L4.34998 12.3001L5.77498 10.8751L10.05 15.1501L19.225 5.9751L20.65 7.4001L10.05 18.0001Z", fill: "currentColor" }));
const Memo = memo(SvgOwnedItems);
export default Memo;
